export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_3-e3d4da8afb03309d79e73cdbe61ceb04.jpg";